module.exports = __webpack_public_path__ + "img/calendar.31059a44.svg";